import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';

import {HttpClient, HttpParams} from '@angular/common/http';
import {DaoGeneric} from '@Services/base/daoService';

import {Observable} from 'rxjs';

import {getParams} from '@Services/common/services-utils';

import {UbCrScr} from '../ub-cr-scr.model';

/**
 * Consultation / recherche Ub / Cr / Scr / Convention, opération
 */
@Injectable({ providedIn: 'root' })
export class ConventionsService extends DaoGeneric<UbCrScr> {
  private url = `${environment.baseUrl}/dar/conventions/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  getUbs(annee: number): Observable<UbCrScr[]> {
    const params = new HttpParams().set('annee', annee.toString());

    return this.httpClient.get<UbCrScr[]>(`${this.url}getUbs/`, {params});
  }

  getCrs(annee: number, ub: string): Observable<UbCrScr[]> {
    const params = new HttpParams()
      .set('annee', annee.toString())
      .set('ub', ub);
    return this.httpClient.get<UbCrScr[]>(`${this.url}getCrs/`, {params});
  }

  getSousCrs(annee: number, ub: string, cr: string): Observable<UbCrScr[]> {
    const params = new HttpParams()
      .set('annee', annee.toString())
      .set('ub', ub)
      .set('cr', cr);
    return this.httpClient.get<UbCrScr[]>(`${this.url}getSousCrs/`, {params});
  }

  getOperation(annee: number, ub: string, cr: string, scr: string): Observable<UbCrScr[]> {
    const params = new HttpParams()
    .set('annee', annee.toString())
    .set('ub', ub)
    .set('cr', cr)
    .set('scr', scr);
    return this.httpClient.get<UbCrScr[]>(`${this.url}getOperation/`, {params});
  }

  search(keyword: string = '', extraParams = null) {
    const url = `${this.url}`;

    const params = getParams(0, 0, keyword, '', extraParams);

    return this.httpClient.get<any[]>(url, {params});
  }
}
